import React from "react";
import { ReactComponent as BlueDiamond } from "svg/blue-diamond.svg";
import { DateTime } from "luxon";
import MediaQuery from "components/MediaQuery";

const ProbuildsStatsSection = ({ characterData, timestamp, dataSource }) => {
  return (
    <>
      <div className="level-one-container">
        {characterData.pageTitle}
        <BlueDiamond />
        {characterData.lvl1Stat}
        <MediaQuery min="DESKTOP_SMALL" max="DESKTOP_LARGE">
          <BlueDiamond />
        </MediaQuery>
        <div>
          Last Updated: <span className="bold-white-text">{DateTime.fromISO(timestamp).toRelative()}</span>
        </div>
        <BlueDiamond />
        <div>
          Data Source: <span className="bold-white-text">{dataSource}</span>
        </div>
      </div>
      <div className="level-two-container">
        <div className="level-two-stat-box">
          <div className="bold-gold-text level-two-stat-text">{characterData.lvl2Stat1}</div>
          <div className="subtitle-text">{characterData.lvl2Stat1Label}</div>
        </div>
        <div className="level-two-divider" />
        <div className="level-two-stat-box">
          <div className="bold-white-text level-two-stat-text">{characterData.lvl2Stat2}</div>
          <div className="subtitle-text">{characterData.lvl2Stat2Label}</div>
          {characterData.lvl2Stat2Sub && <div className="subtitle-text">{characterData.lvl2Stat2Sub}</div>}
        </div>
        <div className="level-two-divider" />
        <div className="level-two-stat-box">
          <div className="bold-white-text level-two-stat-text">{characterData.lvl2Stat3}</div>
          <div className="subtitle-text">Item Level</div>
        </div>
        <div className="level-two-divider" />
        {/* PROBUILDS TODO: Decide what stat to go here */}
        <div className="level-two-stat-box">
          <div className="bold-white-text level-two-stat-text">{characterData.lvl2Stat4}</div>
          <div className="subtitle-text">{characterData.lvl2Stat4Label}</div>
          {characterData.lvl2Stat4Sub && <div className="subtitle-text">{characterData.lvl2Stat4Sub}</div>}
        </div>
      </div>
      <div className="level-three-container">
        <div className="level-three-stat-box">
          <div className="subtitle-text bold-white-text">{characterData.primaryStatLabel}</div>
          <div className="red-text stat-text">{characterData.primaryStatValue}</div>
        </div>
        <div className="level-three-stat-box">
          <div className="subtitle-text bold-white-text">Stamina</div>
          <div className="orange-text stat-text">{characterData.stamina}</div>
        </div>
        <div className="level-three-stat-box">
          <div className="subtitle-text bold-white-text">Critical Strike</div>
          <div className="red-text stat-text">{characterData.crit}</div>
        </div>
        <div className="level-three-stat-box">
          <div className="subtitle-text bold-white-text">Haste</div>
          <div className="green-text stat-text">{characterData.haste}</div>
        </div>
        <div className="level-three-stat-box">
          <div className="subtitle-text bold-white-text">Versatility</div>
          <div className="stat-text">{characterData.versatility}</div>
        </div>
        <div className="level-three-stat-box">
          <div className="subtitle-text bold-white-text">Mastery</div>
          <div className="blue-text stat-text">{characterData.mastery}</div>
        </div>
      </div>
    </>
  );
};

export default ProbuildsStatsSection;
